export default __webpack_public_path__ + "static/media/zone.1be26830.svg";